var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-form"},[(_vm.title)?_c('div',{staticClass:"c-form-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"c-form-content",class:{'inline': _vm.compInline}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }